import settings from '/@/core/settings';
import { _ } from '/@/locale';
import { axFetch } from '/@/store/session/actions';
import { mpTrackEvent } from '/@/store/tracking/mixpanel-events';

const deleteAccount = async ({ user, password, setErrorPassword }) => {
    try {
        const url = `${settings.urls.users.deleteMe}`;
        const res = await axFetch.post(url, { password });

        user.has_usable_password ? setErrorPassword('') : undefined;
        mpTrackEvent('Delete account', { state: 'success' });
        return true;
    } catch (error) {
        if (error.response && error.response.status > 0 && error.response.status < 500) {
            user.has_usable_password ? setErrorPassword(_('Contraseña incorrecta')) : undefined;
        } else {
            setErrorPassword('Ha ocurrido un error...');
        }
        mpTrackEvent('Delete account', { state: 'failed', error_detail: error?.response?.data?.detail });
        return false;
    }
};

export default deleteAccount;
